// extracted by mini-css-extract-plugin
export default {"brand-badge":"BrandIcon_brand-badge__mpurI"};